function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "#6800A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.227 4.66504H9.77298V6.93531H10.227V4.66504Z",
  fill: "#7F7774"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.1081 4.66504H7.65405V6.93531H8.1081V4.66504Z",
  fill: "#7F7774"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3459 4.66504H11.8919V6.93531H12.3459V4.66504Z",
  fill: "#554F4E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6054 4.36216V3.60542C10.6054 3.27103 10.3344 3 10 3C9.66565 3 9.39459 3.27103 9.39459 3.60542V4.36218C9.39459 4.69654 9.66562 4.9676 10 4.9676C10.3344 4.96757 10.6054 4.69652 10.6054 4.36216Z",
  fill: "#3891E9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.4865 4.36216V3.60542C8.4865 3.27103 8.21544 3 7.88108 3C7.54672 3 7.27567 3.27103 7.27567 3.60542V4.36218C7.27567 4.69654 7.5467 4.9676 7.88108 4.9676C8.21547 4.9676 8.4865 4.69652 8.4865 4.36216Z",
  fill: "#68AEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7243 4.36216V3.60542C12.7243 3.27103 12.4533 3 12.1189 3C11.7846 3 11.5135 3.27103 11.5135 3.60542V4.36218C11.5135 4.69654 11.7846 4.9676 12.1189 4.9676C12.4533 4.9676 12.7243 4.69652 12.7243 4.36216Z",
  fill: "#68AEF4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4216 14.9569V16.1677H6.67026V9.0542H12.4216V10.265L10.9081 12.611L12.4216 14.9569Z",
  fill: "#C08577"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3297 9.0542H11.5135V16.1677H13.3297V9.0542Z",
  fill: "#AB5D4A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7243 15.8647L12.1189 16.3188L12.7243 16.7728H13.6324V15.8647H12.7243Z",
  fill: "#D5AEA4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4216 10.2646V14.9566H11.5135L10.9081 12.6106L11.5135 10.2646H12.4216Z",
  fill: "#D5AEA4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5135 10.2646H7.57837V14.9565H11.5135V10.2646Z",
  fill: "#EAD6D2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9081 6.93506L12.7243 9.35668H13.6324V6.93506H10.9081Z",
  fill: "#D5AEA4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7243 6.93506H6.36758V9.35668H12.7243V6.93506Z",
  fill: "#EAD6D2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5406 6.63232V7.54044H13.6324L13.3297 7.08639L13.6324 6.63232H14.5406Z",
  fill: "#AB5D4A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7243 15.8647H6.36758V16.7729H12.7243V15.8647Z",
  fill: "#EAD6D2"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6324 6.63232H5.45947V7.54044H13.6324V6.63232Z",
  fill: "#C08577"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7081 17H6.29189C6.16649 17 6.06485 16.8983 6.06485 16.7729C6.06485 16.6476 6.16646 16.5459 6.29189 16.5459H13.7081C13.8335 16.5459 13.9351 16.6475 13.9351 16.7729C13.9351 16.8983 13.8335 17 13.7081 17Z",
  fill: "#AB5D4A"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4973 8.67575H7.5027C7.3773 8.67575 7.27567 8.57411 7.27567 8.44871C7.27567 8.32334 7.37727 8.22168 7.5027 8.22168H12.4973C12.6227 8.22168 12.7243 8.32332 12.7243 8.44871C12.7243 8.57409 12.6227 8.67575 12.4973 8.67575Z",
  fill: "white"
});

var SvgPolitics = function SvgPolitics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPolitics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/politics.4037f032.svg";
export { ForwardRef as ReactComponent };